import { baseUrl } from "../constants";

// Адреса бэкенда на Convex: функции (REACT_APP_CONVEX_URL, *.convex.cloud) и HTTP-эндпоинты
// (REACT_APP_API_URL: вход админа, /uploads, /resources; на продакшне —
// https://api.engineernow.org).
export const CONVEX_URL = process.env.REACT_APP_CONVEX_URL ?? "";
export const API_URL = baseUrl;
